
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import StemSplitter from '@/pages/StemSplitter';
import DrumRemover from '@/pages/DrumRemover';
import AcapellaExtractor from '@/pages/AcapellaExtractor';
import MultitrackTest from '@/pages/MultitrackTest';
import Auth from '@/pages/Auth';
import Index from '@/pages/Index';
import NotFound from '@/pages/NotFound';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Index />,
  },
  {
    path: '/auth',
    element: <Auth />,
  },
  {
    path: '/ai-stem-splitter',
    element: <StemSplitter />,
  },
  {
    path: '/acapella-extractor',
    element: <AcapellaExtractor />,
  },
  {
    path: '/drum-remover',
    element: <DrumRemover />,
  },
  {
    path: '/multitrack-test',
    element: <MultitrackTest />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}

export default App;
